import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MultimediaManagerDialogLayoutService } from '../multimedia-manager-dialog-layout/multimedia-manager-dialog-layout.service';
import { MultimediaManagerComponent } from '../multimedia-manager/multimedia-manager.component';
import { MultimediaManagerDialogService } from './multimedia-manager-dialog.service';

export interface DialogData {
  multi: boolean;
  editor: boolean;
}
export enum Mode {
  finder = 'finder',
  editor = 'editor'
}
@Component({
  selector: 'app-multimedia-manager-dialog',
  templateUrl: './multimedia-manager-dialog.component.html',
  styleUrls: ['./multimedia-manager-dialog.component.scss']
})
export class MultimediaManagerDialogComponent implements OnInit {

  ModeEnum = Mode;
  mode: Mode;
  element: string;

  constructor(private multimediaManagerDialogService: MultimediaManagerDialogService,
              private multimediaManagerDialogLayoutService: MultimediaManagerDialogLayoutService,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              public dialogRef: MatDialogRef<MultimediaManagerComponent>) {
                this.multimediaManagerDialogService.setMultiOption(data.multi);
                this.multimediaManagerDialogService.setEditorOption(data.editor);
                this.mode = Mode.finder;
              }

  ngOnInit() {
    this.multimediaManagerDialogService.listenSetMode().subscribe(
      (res) => {
        this.mode = res.mode;
        this.element = res.element;
      }
    );
  }

  public hideDetails(e) {
    this.multimediaManagerDialogLayoutService.hideDetails();
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
